import { ICalendarItem, ICalendarSelectorItem } from "../types";

export function convertCalendarItem(item: ICalendarItem, active?: boolean, virtual?: boolean): ICalendarSelectorItem {
  return {
    item,
    active: Boolean(active),
    virtual: Boolean(virtual),
    disabled: Boolean(virtual || item.disabled)
  }
}